import { render, staticRenderFns } from "./DictionaryEntryForm.vue?vue&type=template&id=ebccafe0"
import script from "./DictionaryEntryForm.vue?vue&type=script&lang=js"
export * from "./DictionaryEntryForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports